var H = require("hogan.js");
module.exports = function() { var T = new H.Template({code: function (c,p,i) { var t=this;t.b(i=i||"");if(t.s(t.f("newBadge",c,p,1),c,p,0,13,62,"{{ }}")){t.rs(c,p,function(c,p,t){t.b("  <span class='new-badge'>");t.b(t.v(t.d("t.newBadge",c,p,0)));t.b("</span>");t.b("\n" + i);});c.pop();}return t.fl(); },partials: {}, subs: {  }}, "{{#newBadge}}\n  <span class='new-badge'>{{t.newBadge}}</span>\n{{/newBadge}}\n", H);return T; }();


//////////////////
// WEBPACK FOOTER
// ./src/frontend/helper/search/helper/templates/partial_new_badge.html.mustache
// module id = 101
// module chunks = 0 2